import { Icon, boxShadows, colors, fontSizes, iconSizes } from "@hubrise/react-components"
import styled from "styled-components"

export const Container = styled.div`
  width: 50em;
  height: 20rem;
  max-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Circle = styled.div`
  width: 15rem;
  height: 15rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;

  background-color: ${colors.backgroundLightest};
  border-radius: 50%;
  box-shadow: ${boxShadows.small};
  color: ${colors.textLight};
`

export const StyledIcon = styled(Icon).attrs({ size: iconSizes._25 })``

export const Text = styled.div`
  margin-left: 1rem;
  font-size: ${fontSizes._19};
  line-height: 1.5;
`
